var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.53 6.499-1.06-2.12C.36 2.162-.194 1.053.316.543s1.619.045 3.837 1.155L12.18 5.71c1.56.78 2.341 1.17 2.341 1.789 0 .618-.78 1.008-2.341 1.788l-8.027 4.014C1.935 14.41.825 14.965.316 14.455s.045-1.62 1.154-3.838L2.53 8.5h6.156a1 1 0 0 0 0-2z"
  })));
};
export default SvgSendIcon;